export default function scrollToTop(noDelay = false) {


    setTimeout(() => {

        document.querySelector("#scrollTopAnchor")?.scrollIntoView({ behavior: "smooth" });

    }, noDelay?0: 130);
   
}